import { render, staticRenderFns } from "./ModalValidacaoTramitacao.vue?vue&type=template&id=2f5a5231&scoped=true"
import script from "./ModalValidacaoTramitacao.vue?vue&type=script&lang=js"
export * from "./ModalValidacaoTramitacao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f5a5231",
  null
  
)

export default component.exports